import React from 'react'
import { Col, Row } from 'react-bootstrap'
import illustration from '../../assets/Illustration.png'

const Steps = ({ t }) => {

    const data = [
        { title: "sign_up", caption: "sign_up_caption", image: "" },
        { title: "add_your_items", caption: "add_your_items_caption", image: "" },
        { title: "publish", caption: "publish_caption", image: "" },
        { title: "enjoy", caption: "enjoy_caption", image: "" },
    ]

    return (
        <div className='py-5'>
            <h2 className='fs-1' dangerouslySetInnerHTML={{ __html: t('steps_title') }}></h2>
            <p className='opacity-75'>{t('steps_caption')}</p>
            <div className='mt-5'>
                <Row className='justify-content-between align-items-end'>
                    <Col md="7" lg="6">
                        <div className='d-flex flex-column gap-4'>
                            {data.map((item, index) => (

                                <div className='d-flex gap-3 my-1' key={index}>
                                    <span className='align-self-start border rounded-circle d-flex justify-content-center align-items-center' style={{ width: "50px", height: "50px", minWidth: "50px", maxWidth: "50px", minHeight: "50px", maxHeight: "50px" }}>
                                        {index + 1}
                                    </span>
                                    <span>
                                        <div style={{ fontSize: '120%' }}>{t(item.title)}</div>
                                        <div className='text-secondary mt-2'>{t(item.caption)}</div>
                                    </span>
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col md="5" lg="5">
                        <div className='p-5 shadow-sm rounded-4 d-flex justify-content-center'>
                            <img src={illustration} width="60%" height="60%" alt='Illustration for steps' />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Steps
